import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
} from "@/components/ui/select";
import { EUPlate } from "./EUPlate";
import { NORDIC_COUNTRIES, type NordicCountry } from "./constants";
import { useLanguage } from "@/context/LanguageContext";
import { valuationLabels } from "@/i18n";

interface CountrySelectorProps {
  selectedCountry: NordicCountry;
  onCountryChange: (countryId: string) => void;
  className: string;
}

export const CountrySelector = ({
  selectedCountry,
  onCountryChange,
  className,
}: CountrySelectorProps) => {
  const { language } = useLanguage();
  const vLabels = valuationLabels(language);
  const countryNames =
    (vLabels.registration as { countries?: Record<string, string> })
      ?.countries ?? {};
  return (
    <div className={className}>
      <Select value={selectedCountry.id} onValueChange={onCountryChange}>
        <SelectTrigger className="h-full w-full border-0 bg-transparent hover:bg-transparent focus:ring-0 focus:ring-offset-0 p-0">
          <div className="w-full h-full flex items-center justify-center relative">
            <EUPlate countryCode={selectedCountry.code} />
          </div>
        </SelectTrigger>
        <SelectContent>
          {NORDIC_COUNTRIES.map((country) => (
            <SelectItem key={country.id} value={country.id}>
              <span>{countryNames[country.id] ?? country.name}</span>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
